import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useDebouncedCallback as t, useDebounce as n } from "use-debounce";
export { useDebounce, useDebouncedCallback } from "use-debounce";
import * as e from "react";
import r, { useState as o, useCallback as u, createContext as c, useContext as i, useEffect as a, useMemo as s, useRef as l, useLayoutEffect as d } from "react";
import { isBrowser as f, isFunction as m, runIfFunction as p, queueMicrotask as v } from "@vtex/admin-ui-util";
import w from "tiny-invariant";
import { createPortal as h } from "react-dom";

function g(n) {
  var e = n.initialState,
      r = n.timeoutMs,
      _n$produce = n.produce,
      u = _n$produce === void 0 ? function (t) {
    return t;
  } : _n$produce,
      _o = o(e),
      _o2 = _slicedToArray(_o, 2),
      c = _o2[0],
      i = _o2[1];

  return [c, t(function (t) {
    var n = u(t);
    i(function () {
      return n;
    });
  }, r)];
}

function b(t) {
  var e = t.initialState,
      r = t.timeoutMs,
      _t$produce = t.produce,
      c = _t$produce === void 0 ? function (t) {
    return t;
  } : _t$produce,
      _o3 = o(e),
      _o4 = _slicedToArray(_o3, 2),
      i = _o4[0],
      a = _o4[1],
      _n = n(i, r),
      _n2 = _slicedToArray(_n, 1),
      s = _n2[0];

  return [i, s, u(function (t) {
    var n = c(t);
    a(function () {
      return n;
    });
  }, [c])];
}

var y = c(null);

function E() {
  var t = i(y);
  return w(t, "Do not use useQueryState outside of QueryStateContext"), t;
}

function S(_ref) {
  var t = _ref.children;

  var n = i(y),
      _o5 = o(new URLSearchParams(f ? window.location.search : "")),
      _o6 = _slicedToArray(_o5, 2),
      e = _o6[0],
      u = _o6[1];

  return a(function () {
    if (f && !n) return window.addEventListener("popstate", t), function () {
      window.removeEventListener("popstate", t);
    };

    function t() {
      u(new URLSearchParams(window.location.search));
    }
  }, []), r.createElement(y.Provider, {
    value: {
      queryParams: n ? n.queryParams : e
    }
  }, t);
}

function P(t) {
  var _E = E(),
      n = _E.queryParams,
      e = s(function () {
    return t.keys.reduce(function (t, e) {
      return n.get(e) ? Object.assign(Object.assign({}, t), _defineProperty({}, e, n.get(e))) : t;
    }, {});
  }, [n.toString()]),
      r = l(t.keys.reduce(function (t, e) {
    return n.get(e) ? Object.assign(Object.assign({}, t), _defineProperty({}, e, n.get(e))) : t;
  }, {})),
      o = u(function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!f) return;
    Object.entries(t).forEach(function (t) {
      t[1] ? n.set(t[0], t[1]) : n.delete(t[0]);
    });
    var e = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(n.toString());
    window.history.pushState({
      path: e
    }, "", e);
  }, []);

  return [r.current, o, e];
}

function k(t) {
  var n = t.onTimeout,
      e = t.duration,
      _o7 = o(!0),
      _o8 = _slicedToArray(_o7, 2),
      r = _o8[0],
      c = _o8[1],
      i = l(),
      s = u(function () {
    window.clearTimeout(i.current), c(!1);
  }, []);

  a(function () {
    if (r) return i.current = window.setTimeout(function () {
      n();
    }, e), function () {
      s();
    };
  }, [n, r, e, s]);
  var d = u(function () {
    c(!0);
  }, []);
  return {
    stopTimeout: s,
    startTimeout: d
  };
}

var M = f ? d : a;

function C(t) {
  var n = l(function () {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return M(function () {
    n.current = t;
  }), u(function () {
    var _e;

    var e;

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return null === (e = n.current) || void 0 === e ? void 0 : (_e = e).call.apply(_e, [n].concat(t));
  }, []);
}

function O(_ref2) {
  var t = _ref2.keyMap,
      n = _ref2.onKey,
      e = _ref2.stopPropagation,
      r = _ref2.onKeyDown,
      _ref2$preventDefault = _ref2.preventDefault,
      o = _ref2$preventDefault === void 0 ? !0 : _ref2$preventDefault;
  return function (u) {
    var c;
    if (!t) return;
    var i = t(u);

    if (u.key in i) {
      var _t = i[u.key];
      if (m(_t)) return o && u.preventDefault(), e && u.stopPropagation(), n && n(u), void _t(u);
    }

    r && "current" in r ? null === (c = r.current) || void 0 === c || c.call(r, u) : null == r || r(u);
  };
}

function T(t, n) {
  "function" == typeof t ? t(n) : t && (t.current = n);
}

function j() {
  for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    t[_key2] = arguments[_key2];
  }

  return s(function () {
    if (t.some(Boolean)) return function (n) {
      t.forEach(function (t) {
        T(t, n);
      });
    };
  }, t);
}

function D(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = e.useRef(t);
  return M(function () {
    r.current = t;
  }), e.useCallback(function () {
    var _n3;

    var n;

    for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      t[_key3] = arguments[_key3];
    }

    return null === (n = r.current) || void 0 === n ? void 0 : (_n3 = n).call.apply(_n3, [r].concat(t));
  }, n);
}

function L(t) {
  var n = t.value,
      e = t.defaultValue,
      r = t.onChange,
      _t$shouldUpdate = t.shouldUpdate,
      c = _t$shouldUpdate === void 0 ? function (t, n) {
    return t !== n;
  } : _t$shouldUpdate,
      i = D(r),
      a = D(c),
      _o9 = o(e),
      _o10 = _slicedToArray(_o9, 2),
      s = _o10[0],
      l = _o10[1],
      d = void 0 !== n,
      f = d ? n : s,
      m = u(function (t) {
    var n = p(t, f);
    a(f, n) && (d || l(n), i(n));
  }, [d, i, f, a]);

  return [f, m];
}

function $(t) {
  var _o11 = o(t),
      _o12 = _slicedToArray(_o11, 2),
      n = _o12[0],
      e = _o12[1];

  return M(function () {
    if (t || n) return;
    var r = Math.random().toString(36).substr(2, 6);
    e("id-".concat(r));
  }, [t, n]), t || n;
}

function x() {
  var t = l(null);
  return [t, function () {
    t.current && v(function () {
      var n;
      null === (n = null == t ? void 0 : t.current) || void 0 === n || n.focus();
    });
  }];
}

function R() {
  var t = l(),
      n = l(document.createElement("div")),
      e = document.body;
  a(function () {
    n.current || (n.current = document.createElement("div"));
  }, [n]), a(function () {
    if (!(e instanceof HTMLElement && n.current instanceof HTMLElement)) return;
    var t = n.current;
    return e.appendChild(n.current), function () {
      e.removeChild(t);
    };
  }, [e, n]);
  var r = u(function (_ref3) {
    var t = _ref3.children;
    return null != n.current ? h(t, n.current) : null;
  }, [n]);
  return Object.assign([r, t, n], {
    ref: t,
    Portal: r,
    portalRef: n
  });
}

function q(t) {
  var _t$root = t.root,
      n = _t$root === void 0 ? null : _t$root,
      e = t.rootMargin,
      _t$threshold = t.threshold,
      r = _t$threshold === void 0 ? 0 : _t$threshold,
      u = t.callback,
      _o13 = o(),
      _o14 = _slicedToArray(_o13, 2),
      c = _o14[0],
      i = _o14[1],
      s = l();

  return a(function () {
    if (!c) return;
    s.current = new IntersectionObserver(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          t = _ref5[0];

      u(t);
    }, {
      root: n,
      rootMargin: e,
      threshold: r
    });
    var t = s.current;
    return t.observe(c), function () {
      return t.disconnect();
    };
  }, [c, n, e, r, u]), {
    setNode: i
  };
}

export { S as QueryStateProvider, T as setRef, D as useCallbackRef, L as useControllableState, b as useDebouncedCache, g as useDebouncedState, C as useEventCallback, x as useFieldFocus, j as useForkRef, $ as useId, q as useIntersectionObserver, O as useOnKeyDown, R as usePortal, P as useQueryState, E as useQueryStateContext, M as useSafeLayoutEffect, k as useTimeout };